const Method = {
  FILES: "files",
  WIZARD: "wizard",
  AUTOCUT: "autocut",
};

export default Method;